// pages/PasswordReRegister.js
import PasswordReEnrollment from "../components/PasswordScreen/PasswordReEnrollment";
import Footer from "../components/HomeScreen/Footer";

const PasswordReRegister = () => {
  return (
    <>
      <PasswordReEnrollment />
      <Footer />
    </>
  );
}
export default PasswordReRegister;
